import { useState, useEffect } from 'react';
import isEqual from 'lodash.isequal';

function consentStatusSubscribe({
  onChange,
  onError,
  timeoutMilliseconds
}) {
  let listenerId;
  let canceled = false;
  let gpp;
  let waitingMessage = "__gpp to be available";
  const timeoutTimer = timeoutMilliseconds && setTimeout(() => {
    if (waitingMessage && !canceled) {
      cleanup();
      onError(new Error(`Timed out waiting for ${waitingMessage}`));
    }
  }, timeoutMilliseconds);
  function listener(data, success) {
    if (canceled) {
      return;
    }
    if (!success || data.pingData.cmpStatus === "error") {
      cleanup();
      onError(new Error("The Consent Manager failed with an unspecified error"));
    } else {
      if (data.eventName === "listenerRegistered") {
        listenerId = data.listenerId;
      }
      waitingMessage = "";
      onChange(data.pingData);
    }
  }
  function onGppAvailable(gppFunction) {
    waitingMessage = "__gpp result";
    try {
      const result = gppFunction("addEventListener", listener);
      if (result) {
        listener(result, true);
      }
    } catch (e) {
      const err = new Error("Error adding listener");
      err.cause = e;
      onError(err);
    }
  }
  let pollTimer = setTimeout(pollGpp);
  function pollGpp() {
    gpp = window.__gpp;
    if (gpp) {
      onGppAvailable(gpp);
    } else {
      pollTimer = setTimeout(pollGpp, 100);
    }
  }
  function cleanup() {
    canceled = true;
    if (pollTimer) {
      clearTimeout(pollTimer);
      pollTimer = null;
    }
    clearTimeout(timeoutTimer);
    if (gpp && listenerId) {
      gpp("removeEventListener", listener, listenerId);
      listenerId = void 0;
    }
  }
  cleanup[Symbol.dispose] = cleanup;
  return cleanup;
}

function getConsentStatus(options) {
  return new Promise((resolve, reject) => {
    const unsubscribe = consentStatusSubscribe({
      onChange(data) {
        unsubscribe();
        resolve(data);
      },
      onError(error) {
        reject(error);
      },
      timeoutMilliseconds: options?.timeoutMilliseconds
    });
  });
}

function useConsentStatus(options) {
  const [consentStatus, setConsentStatus] = useState({
    state: "pending",
    data: void 0
  });
  useEffect(() => {
    const cleanup = consentStatusSubscribe({
      onChange(data) {
        const status = { state: "success", data };
        setConsentStatus(
          (oldStatus) => isEqual(status, oldStatus) ? oldStatus : status
        );
      },
      onError(error) {
        setConsentStatus({ state: "error", error, data: void 0 });
      },
      timeoutMilliseconds: options?.timeoutMilliseconds
    });
    return () => cleanup();
  }, []);
  return consentStatus;
}

export { getConsentStatus, useConsentStatus };
//# sourceMappingURL=index.mjs.map
